import React, { Fragment, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux'
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { Store } from 'react-notifications-component';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import TextField from '@mui/material/TextField';
import { getInformeByIdSolicitud } from '../../../../../../../redux/DucksUnidadInspeccion/InformeCumplimientoDuck';
import { actualizarCertificadoFC13, generarCertificadoFC13 } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { ObtenerInformacionCliente } from '../../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../../../../../redux/AppDucks';
import Button from '@mui/material/Button'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import moment from 'moment'

const styleForm = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px'
};

const styleModalConfirmacion = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    width: 500, bgcolor: 'background.paper', boxShadow: 24,
    p: 4, fontSize: '20px', textAlign: 'center', borderRadius: '8px'
};

const theme = createTheme({
    palette: {
        primary: {
            main: "#7D9A47"
        },
        secondary: {
            main: "#DC3545"
        }
    },
    typography: {
        fontFamily: "Montserrat",
        textTransform: 'none',
        button: {
            fontSize: 16,
            fontWeight: 500,
            fontFamily: "Montserrat",
            textTransform: 'none'
        }
    }
});

function GenerarCertificadoFC13Component(props) {

    const informacionCliente = useSelector(store => store.SolicitudesFC01_OC.informacionCliente)

    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)
    const [valuesForm, setValuesForm] = React.useState();
    const informe = useSelector(store => store.Informe.informe)

    let titulo = 'Nuevo archivo'
    let habilitarBoton = false
    let fechaActual = moment().format('YYYY-MM-DD')
    let fechaVencimiento = informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.fechavencimiento?.substring(0, 10)
    let diasVencimiento = moment(fechaActual).diff(moment(fechaVencimiento), 'days')

    if (diasVencimiento >= 0) habilitarBoton = true
    if (diasVencimiento < 0) titulo = 'Archivo vigente. No es posible actualizar.'

    const [openModal, setOpenModal] = React.useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    }
    const modalFormulario = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleForm}>
                        <Typography id="modal-modal-title" variant="h4" component="h2">
                            <div style={{ textAlign: "center", fontFamily: 'Montserrat' }}> Certificado NOM </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <div className='container'>
                                <Formik
                                    initialValues={{
                                        fechainicio: '',
                                        fechaactualizacion: '',
                                        fechavencimiento: '',
                                        observaciones: '',
                                        folio: ''
                                    }}
                                    enableReinitialize={true}
                                    validate={(values) => {
                                        const errors = {}

                                        if (values.fechainicio == '') {
                                            errors.fechainicio = 'Seleccione la fecha de inicio de vigencia';
                                        }

                                        if (values.fechaactualizacion == '') {
                                            errors.fechaactualizacion = 'Seleccione la fecha de actualización';
                                        }

                                        if (values.fechavencimiento == '') {
                                            errors.fechavencimiento = 'Seleccione la fecha de vencimiento';
                                        }

                                        if (values.observaciones == '') {
                                            errors.observaciones = 'Ingrese las observaciones';
                                        }

                                        if (values.folio == '') {
                                            errors.folio = 'Ingrese el folio';
                                        }
                                        return errors;
                                    }}
                                    onSubmit={(values) => {
                                        handleOpenConfirmar(values)
                                    }}
                                >
                                    {(props) => (
                                        <Form>
                                            <div className='form-row' style={{ fontFamily: 'Montserrat' }}>
                                                {informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.idestatuspdfoc == 3 &&
                                                    <div className='row'>
                                                        <TextField error id="outlined-error" label="Observaciones Beneficiario" defaultValue="Observaciones beneficiario" multiline
                                                            value={informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.observacionesbeneficiario} />
                                                    </div>
                                                }
                                                <div className="form-group col">
                                                    <label for="folio" className="row-sm-2 row-form-label">No. de Certificado: </label>
                                                    <div className="col">
                                                        <Field type="text" className="form-control" id="folio" name="folio" />
                                                        <ErrorMessage name="folio" component="div" style={{ color: 'red', fontSize: '10pt' }} />
                                                    </div>
                                                </div>
                                                <br></br>
                                                <div className="form-group col">
                                                    <label for="fechainicio" className="row-sm-2 row-form-label">FECHA DE INICIO DE VIGENCIA: </label>
                                                    <div className="col">
                                                        <Field type="date" className="form-control" id="fechainicio" name="fechainicio" />
                                                        <ErrorMessage name="fechainicio" component="div" style={{ color: 'red', fontSize: '10pt' }} />
                                                    </div>
                                                </div>
                                                <br></br>
                                                <div className="form-group col">
                                                    <label for="fechaactualizacion" className="row-sm-2 row-form-label">FECHA DE ACTUALIZACIÓN: </label>
                                                    <div className="col">
                                                        <Field type="date" className="form-control" id="fechaactualizacion" name="fechaactualizacion" />
                                                        <ErrorMessage name="fechaactualizacion" component="div" style={{ color: 'red', fontSize: '10pt' }} />
                                                    </div>
                                                </div>
                                                <br></br>
                                                <div className="form-group col">
                                                    <label for="fechavencimiento" className="row-sm-2 row-form-label">FECHA DE VENCIMIENTO: </label>
                                                    <div className="col">
                                                        <Field type="date" className="form-control" id="fechavencimiento" name="fechavencimiento" />
                                                        <ErrorMessage name="fechavencimiento" component="div" style={{ color: 'red', fontSize: '10pt' }} />
                                                    </div>
                                                </div>
                                                <br></br>
                                                <div className="form-group col">
                                                    <label for="observaciones" className="row-sm-2 row-form-label">OBSERVACIONES: </label>
                                                    <div className="col">
                                                        <Field type="text" className="form-control" id="observaciones" name="observaciones" />
                                                        <ErrorMessage name="observaciones" component="div" style={{ color: 'red', fontSize: '10pt' }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <br></br>                                            
                                            <ThemeProvider theme={theme}>
                                                <div className='text-center'>
                                                    <div className="col">
                                                        <Button variant="contained" color="primary" style={{ width: '75%' }} type='submit'>Guardar</Button>
                                                    </div>
                                                </div>
                                            </ThemeProvider>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    const [modalConfirmar, setModalConfirmar] = React.useState(false);
    const handleOpenConfirmar = (values) => {
        setModalConfirmar(true);
        setValuesForm(values)
    }
    const handleCloseConfirmar = () => {
        setModalConfirmar(false);
    }
    const ModalConfirmarFC13 = () => {
        return (
            <Modal
                open={modalConfirmar}
                onClose={handleCloseConfirmar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">                
                <ThemeProvider theme={theme}>
                    <Box sx={styleModalConfirmacion}>
                        <h3>Generar Certificado</h3> <br/>
                        ¿Está seguro de querer generar este certificado NOM? <br/><br/>
                        <Button variant="contained" color="primary" style={{ width: '75%' }} onClick={generarCertificadoCumplimiento}>Sí, estoy seguro</Button>
                    </Box>
                </ThemeProvider>
            </Modal>
        )
    }

    const generarCertificadoCumplimiento = async () => {
        await dispatch(actualizarLoadingApp_true())

        const monthNames = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

        const fechainicio = new Date(valuesForm.fechainicio)
        const diaInicio = ('0' + (fechainicio.getDate() + 1)).slice(-2);
        const mesfechainicio = fechainicio.getMonth();
        const añofechainicio = fechainicio.getFullYear();
        const fechainicioFinal = diaInicio + ' de ' + monthNames[mesfechainicio] + ' de ' + añofechainicio

        const fechaactualizacion = new Date(valuesForm.fechaactualizacion)
        const diafechaactualizacion = ('0' + (fechaactualizacion.getDate() + 1)).slice(-2);
        const mesfechaactualizacion = fechaactualizacion.getMonth();
        const añofechaactualizacion = fechaactualizacion.getFullYear();

        const fechaactualizacionFinal = diafechaactualizacion + ' de ' + monthNames[mesfechaactualizacion] + ' de ' + añofechaactualizacion
        const fechavencimiento = new Date(valuesForm.fechavencimiento)
        const diafechavencimiento = ('0' + (fechavencimiento.getDate() + 1)).slice(-2);
        const mesfechavencimiento = fechavencimiento.getMonth();
        const añoffechavencimiento = fechavencimiento.getFullYear();
        const fechavencimientoFinal = diafechavencimiento + ' de ' + monthNames[mesfechavencimiento] + ' de ' + añoffechavencimiento


        let filtrodomicilio = props?.solicitud?.domiciliofiscalcliente?.filter(domicilio => domicilio?.isbaja == false && domicilio?.domicilioprincipal == true)
    let cadenaDomicilio = ''
    const arrayDomicilio = []
    if (filtrodomicilio?.[0]?.calle === 'Otro') arrayDomicilio.push(filtrodomicilio?.[0]?.otracalle)
    else arrayDomicilio.push(filtrodomicilio?.[0]?.calle)
    if (filtrodomicilio?.[0]?.numerointerior != null && filtrodomicilio?.[0]?.numerointerior != '') arrayDomicilio.push(filtrodomicilio?.[0]?.numerointerior)
    else arrayDomicilio.push('S/N')
    if (filtrodomicilio?.[0]?.numeroexterior != null && filtrodomicilio?.[0]?.numeroexterior != '') arrayDomicilio.push(filtrodomicilio?.[0]?.numeroexterior)
    else arrayDomicilio.push('S/N')

    if (filtrodomicilio?.[0]?.colonia != null && filtrodomicilio?.[0]?.colonia != '') arrayDomicilio.push(filtrodomicilio?.[0]?.colonia)
    if (filtrodomicilio?.[0]?.localidad != null && filtrodomicilio?.[0]?.localidad != '') arrayDomicilio.push(filtrodomicilio?.[0]?.localidad)
    if (filtrodomicilio?.[0]?.municipioalcaldia != null && filtrodomicilio?.[0]?.municipioalcaldia != '') arrayDomicilio.push(filtrodomicilio?.[0]?.municipioalcaldia)
    if (filtrodomicilio?.[0]?.estado != null && filtrodomicilio?.[0]?.estado != '') arrayDomicilio.push(filtrodomicilio?.[0]?.estado)
    if (filtrodomicilio?.[0]?.codigopostal != null && filtrodomicilio?.[0]?.codigopostal != '') arrayDomicilio.push(filtrodomicilio?.[0]?.codigopostal)
    for (const i in arrayDomicilio) {
        if (Number(i) === 0) {
            cadenaDomicilio += arrayDomicilio[i]
        } else if (Number(i) + Number(1) === arrayDomicilio.length) {
            cadenaDomicilio += ', ' + arrayDomicilio[i]
        } else {
            cadenaDomicilio += ', ' + arrayDomicilio[i]
        }
    }

        if (informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.length == 0) {
            let dataForm = {
                fechainicioatendida: fechainicio.toISOString(),
                fechaactualizacion: fechaactualizacion.toISOString(),
                fechavencimiento: fechavencimiento.toISOString(),
                observaciones: valuesForm.observaciones,
                idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
                idestatuspdfoc: 1
            }
            const data = {
                fechainicio: fechainicioFinal,
                fechaactualizacion: fechaactualizacionFinal,
                fechavencimiento: fechavencimientoFinal,
                instalacion: informacionCliente?.fc_01_solicitudderegistro?.fi_25_informecumplimientonom?.[0]?.fi_25_caratula[0].fi_25_anexo_instalacion_historial[0],
                informacionGeneral:  props?.solicitud ,
                domiciliofiscal:cadenaDomicilio,
                //tipoUnidad: informe.informaciongeneralinstalacioncliente.anexocliente[0].idtipoanexo,
                //nodictamen: informe.fi_25_caratula[0].ninforme,
                //responsable: informe.fi_25_caratula[0].fi_25_responsables,
                observaciones: valuesForm.observaciones,
                folio: valuesForm.folio,
                informes: informacionCliente?.fc_01_solicitudderegistro?.fi_25_informecumplimientonom,
                idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
                dataForm: dataForm
            }

            await dispatch(generarCertificadoFC13(data))
        } else {
            let dataForm = {
                fechainicioatendida: fechainicio.toISOString(),
                fechaactualizacion: fechaactualizacion.toISOString(),
                fechavencimiento: fechavencimiento.toISOString(),
                observaciones: valuesForm.observaciones,
                idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
                idsolicitudesocfc13: informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.idsolicitudesocfc13,
                idestatuspdfoc: 1
            }
            const data = {
                fechainicio: fechainicioFinal,
                fechaactualizacion: fechaactualizacionFinal,
                fechavencimiento: fechavencimientoFinal,
                instalacion: informacionCliente?.fc_01_solicitudderegistro?.fi_25_informecumplimientonom?.[0]?.fi_25_caratula[0].fi_25_anexo_instalacion_historial[0],
                informacionGeneral:  props?.solicitud ,
                domiciliofiscal:cadenaDomicilio,
                //tipoUnidad: informe.informaciongeneralinstalacioncliente.anexocliente[0].idtipoanexo,
                //nodictamen: informe.fi_25_caratula[0].ninforme,
                //responsable: informe.fi_25_caratula[0].fi_25_responsables,
                observaciones: valuesForm.observaciones,
                folio: valuesForm.folio,
                informes: informacionCliente?.fc_01_solicitudderegistro?.fi_25_informecumplimientonom,
                idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
                dataForm: dataForm
            }

            await dispatch(actualizarCertificadoFC13(data))
        }
        await dispatch(ObtenerInformacionCliente(informacionCliente?.idsolicitudesuifc01))
        await dispatch(actualizarLoadingApp_false())
    }

    return (
        <Fragment>
            <Tooltip title={titulo}>
                <span>
                    <IconButton size="large" onClick={() => setOpenModal(true)}
                        disabled={informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.idestatuspdfoc == 4 && habilitarBoton == false}> <NoteAddIcon fontSize="inherit"
                            style={(informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.idestatuspdfoc == null ||
                                informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.idestatuspdfoc == 1 ||
                                informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.idestatuspdfoc == 2) ? { fill: '#2B2B2B' } :
                                informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.idestatuspdfoc == 3 ? { fill: 'red' } :
                                    informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.idestatuspdfoc == 4 ? { fill: 'green' } : ''} /> </IconButton>
                </span>
            </Tooltip>
            {modalFormulario()}
            {ModalConfirmarFC13()}
        </Fragment>
    );
};


export default withRouter(GenerarCertificadoFC13Component)